import { MovementDataStore } from '@skinsoft/entity';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { EntityHistory } from '@skinsoft/ui';
import { defineComponent } from 'vue';

import { toHistoryRecord$ } from '../../serializer/history';

export const MovementHistory = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sEntityHistory: EntityHistory,
    },
    props: ['targetRouteName'],
    template: require('./movement-history.html'),
    data() {
        return {
            // $movementDataStore (used in the template) is a Vue.prototype global installed by
            // MovementDataStore's Vue.use(), not per-instance state, so it has no data field here
            historyStates: MovementDataStore.historyStates,
            serializer: toHistoryRecord$,
            sortFields: MovementDataStore.sortFields,
        }
    },
})
